/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'closemodal': {
    width: 21,
    height: 22,
    viewBox: '0 0 21 22',
    data: '<path pid="0" _fill="#FFF" fill-rule="evenodd" d="M21.015 1.77l-9.07 9.07 9.07 9.073-1.432 1.432-9.071-9.072-9.072 9.072-1.432-1.432 9.07-9.072-9.07-9.07L1.44.337l9.072 9.07 9.07-9.07 1.433 1.432z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/closemodal.js